import { Box, Stack } from "@mui/material"
import { HomeCard } from "../common/HomeCard"
import HomeTableEquipmentChart from "./HomeTableEquipmentChart"
import HomeTableEquipmentTable from "./HomeTableEquipmentTable"

export const HomeTableEquipment = () => {
    return (
        <HomeCard title="Equipment Reliability, Availability, Maintainability">
            <Stack spacing={4}>
                <HomeTableEquipmentChart />
                <Box>
                    <HomeTableEquipmentTable />
                </Box>
            </Stack>
        </HomeCard>
    )
}